import * as React from "react";
import { useRamp } from "../hooks/useRamp";
import { Ramp } from "../types";
import { RampSkeleton } from "../screens/Ramp/RampSkeleton";

type Props = {
  ramp_id: string;
  isReference: boolean;
  includeReferenceImage?: boolean;
};

const RampStateContainerState = React.createContext<{
  ramp: Ramp;
  setRamp: React.Dispatch<React.SetStateAction<Ramp>>;
  history: any;
  isReference: boolean;
  includeReferenceImage?: boolean;
} | undefined>(undefined);

export const RampStateContainer: React.FC<{
  children?: React.ReactNode;
  initialState: Props;
}> = ({ children, initialState }) => {
  const { ready, ramp, setRamp, history } = useRamp(
    initialState.ramp_id,
    initialState.isReference ?? false,
    initialState.includeReferenceImage ?? false
  );
  return (
    <RampStateContainerState.Provider
      value={{
        ramp,
        setRamp,
        history,
        isReference: initialState.isReference,
      }}
    >
      {ready ? children : <RampSkeleton />}
    </RampStateContainerState.Provider>
  );
};

/**
 * Hook into the current identity context.
 */
export const useRampState = () => {
  const context = React.useContext(RampStateContainerState);
  if (!context) {
    throw new Error("useRampState must be used within a RampStateContainer");
  }
  return context;
};

/**
 * Optional hook that returns undefined if not within a RampStateContainer.
 * Use this when the component might be rendered in both Ramp and non-Ramp contexts.
 */
export const useOptionalRampState = () => {
  const context = React.useContext(RampStateContainerState);
  return context;
};
